module.exports = __webpack_public_path__ + "static/media/tag_veloe@2x.a76ebff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/tag_veloe@2x.png
// module id = 629
// module chunks = 0